import { render, staticRenderFns } from "./nf.vue?vue&type=template&id=0236f4c6&"
import script from "./nf.vue?vue&type=script&lang=js&"
export * from "./nf.vue?vue&type=script&lang=js&"
import style0 from "./nf.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports